import { create } from 'zustand';

export enum ReportStates {
  Idle = 'idle',
  Generating = 'generating',
  Downloading = 'downloading',
  Generated = 'Generated',
  Closed = 'closed',
}
// Above FLOATING_PANEL_Z_INDEX (and the color menu at that value + 1).
export const REPORT_DOWNLOAD_OVERLAY_Z_INDEX = 10050;
export const REPORT_DOWNLOAD_DIALOG_Z_INDEX = 10060;

export enum ReportDestinations {
  Download = 'Download',
  VeevaVault = 'Veeva Vault',
  CompleteWithEsko = 'Complete with Esko',
  FinishWithVeraciti = 'Finish with Veraciti',
  CompleteWithVerifyAPI = 'Complete with Verify Compare API',
}

type ReportState = {
  reportState: ReportStates;
  reportDestination: ReportDestinations;
  reportPath: string;
  lastReportId: string;
  isMultiInspection: boolean;
  setReportState: (reportState: ReportStates) => void;
  setReportDestination: (destination: ReportDestinations) => void;
  setReportPath: (reportPath: string) => void;
  setLastReportId: (reportId: string) => void;
  setIsMultiInspection: (isMultiInspection: boolean) => void;
};

export const useReportState = create<ReportState>((set) => ({
  reportState: ReportStates.Closed,
  reportDestination: ReportDestinations.Download,
  reportPath: '',
  lastReportId: '',
  isMultiInspection: false,
  setReportState: (reportState) => set((state) => ({ ...state, reportState })),
  setReportDestination: (reportDestination) => set((state) => ({ ...state, reportDestination })),
  setReportPath: (reportPath) => set((state) => ({ ...state, reportPath })),
  setLastReportId: (reportId) => set((state) => ({ ...state, lastReportId: reportId })),
  setIsMultiInspection: (isMultiInspection) => set((state) => ({ ...state, isMultiInspection })),
}));
